export default function RadioCard({ id, selected, onSelect, icon, title, sub, badge, badgePaid }) {
  return (
    <label className={`ck-radio-card${selected ? ' selected' : ''}`} onClick={() => onSelect(id)}>
      <input type="radio" readOnly checked={selected} />
      <div className="ck-radio-indicator">
        {selected ? (
          <div className="ck-radio-indicator-check">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
        ) : (
          <div className="ck-radio-indicator-dot" />
        )}
      </div>
      {icon && <div className="ck-radio-icon">{icon}</div>}
      <div className="ck-radio-body">
        <p className="ck-radio-title">{title}</p>
        {sub && <p className="ck-radio-sub">{sub}</p>}
      </div>
      {badge && <span className={`ck-radio-badge${badgePaid ? ' paid' : ''}`}>{badge}</span>}
    </label>
  );
}
